import React from 'react';
import './Preloader.css'; // We will create this CSS file next

const Preloader = () => {
  return (
    <div className="preloader-overlay">
      <div className="preloader-spinner"></div>
    </div>
  );
};

export default Preloader;